import http from './http'

export default {
    /**
     * Consulta los tags
     * @returns {Promise}
     */
    all() {
        return http.get('tags');
    },

    /**
     * Crea un nuevo tag.
     * @param {Object} tag 
     * @returns {Promise}
     */
    add(tag) {
        return http.post(`tags`, tag)
    },

    /**
     * Actualiza un tag.
     * @param {int} tag 
     * @param {Object} payload 
     * @returns {Promise}
     */
    update(tag, payload) {
        return http.put(`tags/${tag}`, payload)
    },

    /**
     * Elimina un tag.
     * @param {int} tag 
     * @param {Object} payload 
     * @returns {Promise}
     */
    delete(tag) {
        return http.delete(`tags/${tag}`)
    }
}